/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CouponCreateRequest = {
    /**
     * Code the customer enters at checkout. Normalized to upper-case.
     */
    code: string;
    /**
     * Internal name shown in admin/partner lists
     */
    name: string;
    /**
     * percent | fixed
     */
    discountType: CouponCreateRequest.discountType;
    /**
     * Percent (1..100) for percent, cents for fixed
     */
    discountValue: number;
    /**
     * Required for fixed coupons (EUR only — checkout currency).
     */
    currency?: string | null;
    /**
     * How many months the discount applies (1 = first invoice only). Required unless lifetime=true.
     */
    durationInMonths?: number | null;
    /**
     * Admin only: discount for the lifetime of the subscription (ignores durationInMonths)
     */
    lifetime?: boolean;
    /**
     * ISO 8601 UTC. NULL = valid immediately
     */
    startsAt?: string | null;
    /**
     * ISO 8601 UTC. NULL = no end
     */
    endsAt?: string | null;
    /**
     * Total paid redemptions. NULL = unlimited
     */
    maxRedemptions?: number | null;
    /**
     * Eligible product categories = Product.pluginName values (e.g. "mobile", "content_master"). Empty/NULL = all products
     */
    pluginNames?: Array<string> | null;
    /**
     * Admin only: customer-specific coupon — only this user may redeem it
     */
    boundUserId?: string | null;
};
export namespace CouponCreateRequest {
    /**
     * percent | fixed
     */
    export enum discountType {
        PERCENT = 'percent',
        FIXED = 'fixed',
    }
}

